import React from 'react';
import style from './semantic-search-toggle.module.scss';

const SemanticSearchToggleView = ({
  useSemanticSearch,
  onUseSemanticSearchChange,
}) => (
  <>
    <br/>
    <h3>Search Settings</h3>
    <div className={style['toggle-wrapper']}>
      <div className={style['checkbox-item']}>
        <label
          htmlFor='use-semantic-search'
        >
          Use Semantic Search for Reviews
        </label>
        <input
          type='checkbox'
          id='use-semantic-search'
          className={style['checkbox']}
          value='useSemanticSearch'
          name='useSemanticSearch'
          onChange={() => { onUseSemanticSearchChange(!useSemanticSearch) }}
          checked={!!useSemanticSearch}
        />
      </div>
    </div>
  </>
);

export default SemanticSearchToggleView;
